import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import {ComponentsModule} from '../components/components.module';
import {TabsModule} from 'ngx-bootstrap/tabs';

import { TableModule } from 'primeng/table';
import { LocationsViewComponent } from './list/list.component';
import { LocationsService } from './locations.service';
import { LocationsResolver } from './list/list.resolver';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LocationCollectionsService } from '../location-collections/location-collections.service';
import { AddLocationComponent } from './new/new.component';
import { EditLocationComponent } from './edit/edit.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        RouterModule,
        TabsModule.forRoot(),
        TableModule,
        BsDropdownModule.forRoot(),
    ],
    declarations: [
        LocationsViewComponent,
        AddLocationComponent,
        EditLocationComponent
    ],
    exports: [
        LocationsViewComponent
    ],
    providers: [
        LocationsService,
        { provide: 'LocationResolver', useValue: LocationsResolver },
        LocationCollectionsService
    ]
})
export class LocationsModule { }
